import { FC, SVGProps } from 'react';

export const UpIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 6C16.2146 6 16.4189 6.09193 16.5613 6.25252L24.5613 15.2782C24.836 15.5881 24.8075 16.0622 24.4975 16.3369C24.1875 16.6117 23.7135 16.5831 23.4387 16.2731L16.9248 8.9241C16.8638 8.85524 16.75 8.89841 16.75 8.99043V24.75C16.75 25.1642 16.4142 25.5 16 25.5C15.5858 25.5 15.25 25.1642 15.25 24.75V8.99043C15.25 8.89841 15.1362 8.85524 15.0752 8.9241L8.56127 16.2731C8.28652 16.5831 7.8125 16.6117 7.50253 16.3369C7.19255 16.0622 7.164 15.5881 7.43875 15.2782L15.4387 6.25252C15.5811 6.09193 15.7854 6 16 6Z"
			fill="currentColor"
		/>
	</svg>
);
